import * as React from "react";
import Icon from "../Icon";
import styles from "./vendors.module.scss";
import { EventVendorQuery } from "@src/@types/api.d";
import { decodeHtmlEntities } from "@src/utils/general";

type Props = {
  eventId: number;
  eventVendorData: EventVendorQuery;
  sectionImage?: string;
};

const Vendors: React.FC<Props> = ({ eventId, eventVendorData }) => {
  return !!eventVendorData?.eventVendor &&
    eventVendorData?.eventVendor.length > 0 ? (
    <div className={styles["home__social"]}>
      <div className={styles["home__social-container"]}>
        <div className={styles["home__social-container-row"]}>
          {eventVendorData?.eventVendor?.map((vendor, index) => {
            const decodedName = decodeHtmlEntities(vendor?.name);
            const decodedRole = decodeHtmlEntities(vendor?.role);
            const decodedEmail = decodeHtmlEntities(vendor?.email);
            const decodedInstagramHandle = decodeHtmlEntities(
              vendor?.instagram_handle
            );
            const normalizedInstagramHandle = decodedInstagramHandle
              .trim()
              .replace(/^@/, "")
              .replace(/^https?:\/\/www\.instagram\.com\//i, "")
              .replace(/\/$/, "");

            return (
              <div
                key={`vendors-home-page-${index}`}
                className={styles["home__social-box"]}
              >
                <h1 className={styles["home__social-heading"]}>
                  {decodedName}
                </h1>
                <p className={styles["home__social-sub-heading"]}>
                  {decodedRole}
                </p>
                <p className={styles["home__social-sub-heading"]}>
                  {decodedEmail}
                </p>
                <div className={styles["home__social-icons"]}>
                  {/* <div className={styles["home__social-icon"]}>
									<Icon iconName="facebook" />
								</div>
								<div className={styles["home__social-icon"]}>
									<Icon iconName="twitter" />
								</div> */}
                  {!!normalizedInstagramHandle && (
                    <a
                      target="_blank"
                      href={`https://www.instagram.com/${normalizedInstagramHandle}/`}
                      rel="noopener noreferrer"
                      className={styles["home__social-icon"]}
                    >
                      <Icon iconName="instagram" />
                    </a>
                  )}
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  ) : (
    <></>
  );
};

export default Vendors;
